import React, { useEffect, useState } from 'react';
import { View, Text, ActivityIndicator, StyleSheet, Platform } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { configuracionService } from '../lib/services/configuracion';

type VotacionWebGateProps = {
  children: React.ReactNode;
};

/**
 * En web, bloquea /r/:qr y /votar/:id si la configuración global lo desactiva
 * y redirige a /app (página de descarga). En app nativa no aplica restricción.
 */
export function VotacionWebGate({ children }: VotacionWebGateProps) {
  const navigate = useNavigate();
  const [estado, setEstado] = useState<'pendiente' | 'permitido' | 'redirigiendo'>(
    Platform.OS === 'web' ? 'pendiente' : 'permitido',
  );

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    let cancelado = false;
    (async () => {
      const habilitada = await configuracionService.isVotacionWebHabilitada();
      if (cancelado) return;
      if (!habilitada) {
        setEstado('redirigiendo');
        navigate('/app', { replace: true });
        return;
      }
      setEstado('permitido');
    })();
    return () => {
      cancelado = true;
    };
  }, [navigate]);

  if (estado === 'pendiente') {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color="#A20000" />
        <Text style={styles.muted}>Cargando…</Text>
      </View>
    );
  }

  if (estado === 'redirigiendo') {
    return null;
  }

  return <>{children}</>;
}

const styles = StyleSheet.create({
  centered: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    backgroundColor: '#F5F6F8',
  },
  muted: {
    marginTop: 12,
    fontSize: 15,
    color: '#6b7280',
  },
});
